/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Position,
    PositionFromJSON,
    PositionFromJSONTyped,
    PositionToJSON,
    Stream,
    StreamFromJSON,
    StreamFromJSONTyped,
    StreamToJSON,
} from './';

/**
 * 
 * @export
 * @interface GpsLossEventInterval
 */
export interface GpsLossEventInterval {
    /**
     * 
     * @type {string}
     * @memberof GpsLossEventInterval
     */
    monitoredObjectId: string;
    /**
     * 
     * @type {number}
     * @memberof GpsLossEventInterval
     */
    clientId: number;
    /**
     * 
     * @type {Position}
     * @memberof GpsLossEventInterval
     */
    positionStart?: Position;
    /**
     * 
     * @type {Position}
     * @memberof GpsLossEventInterval
     */
    positionEnd?: Position;
    /**
     * 
     * @type {Date}
     * @memberof GpsLossEventInterval
     */
    start: Date;
    /**
     * 
     * @type {Date}
     * @memberof GpsLossEventInterval
     */
    end?: Date;
    /**
     * 
     * @type {string}
     * @memberof GpsLossEventInterval
     */
    eventId?: string;
    /**
     * 
     * @type {Stream}
     * @memberof GpsLossEventInterval
     */
    stream?: Stream;
    /**
     * 
     * @type {string}
     * @memberof GpsLossEventInterval
     */
    type?: GpsLossEventIntervalTypeEnum;
}

export function GpsLossEventIntervalFromJSON(json: any): GpsLossEventInterval {
    return GpsLossEventIntervalFromJSONTyped(json, false);
}

export function GpsLossEventIntervalFromJSONTyped(json: any, ignoreDiscriminator: boolean): GpsLossEventInterval {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'monitoredObjectId': json['monitored_object_id'],
        'clientId': json['client_id'],
        'positionStart': !exists(json, 'position_start') ? undefined : PositionFromJSON(json['position_start']),
        'positionEnd': !exists(json, 'position_end') ? undefined : PositionFromJSON(json['position_end']),
        'start': (new Date(json['start'])),
        'end': !exists(json, 'end') ? undefined : (new Date(json['end'])),
        'eventId': !exists(json, 'event_id') ? undefined : json['event_id'],
        'stream': !exists(json, 'stream') ? undefined : StreamFromJSON(json['stream']),
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

export function GpsLossEventIntervalToJSON(value?: GpsLossEventInterval | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'monitored_object_id': value.monitoredObjectId,
        'client_id': value.clientId,
        'position_start': PositionToJSON(value.positionStart),
        'position_end': PositionToJSON(value.positionEnd),
        'start': (value.start.toISOString()),
        'end': value.end === undefined ? undefined : (value.end.toISOString()),
        'event_id': value.eventId,
        'stream': StreamToJSON(value.stream),
        'type': value.type,
    };
}

/**
* @export
* @enum {string}
*/
export enum GpsLossEventIntervalTypeEnum {
    GpsLoss = 'gps_loss'
}


